import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { DuplicateHookPayload } from '@rossum/api-client/hooks';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { QUERY_KEY_HOOKS } from './useHooks';

type UseDuplicateHookProps = {
  onSuccess?: () => void;
};

export const useDuplicateHook = ({ onSuccess }: UseDuplicateHookProps) => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: ({
      hookId,
      payload,
    }: {
      hookId: number;
      payload: DuplicateHookPayload;
    }) => api.request(endpoints.hooks.duplicate(hookId, payload)),

    onSuccess: () => {
      notify.default({
        title: intl.formatMessage({
          id: 'containers.settings.extensions.duplicateExtension.successMessage',
        }),
      });
      queryClient.invalidateQueries([QUERY_KEY_HOOKS]);
      onSuccess?.();
    },

    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'containers.settings.extensions.duplicateExtension.errorMessage',
        }),
      });
    },
  });
};
